/* global Sys, Services */
Sys.ns("Services");

/**
 * The Error Service.
 *
 * @class Services.Error
 * @extends Services.Base
 */
Services.Error = {
    constructor: function() {
        Services.Error.superclass.constructor.apply(this, arguments);
    },

    _setupEvents: function() {
        this.observable.on({
            "notify:errorManager.error": this._errorTriggered.bind(this),
            "notify:dialogBoxClosed": this._dialogBoxClosed.bind(this)
        });
    },

    /**
     * Handles the error.
     *
     * @param {number} [code] The error code to handle.
     * @returns {void}
     */
    handleError: function(code) {
        this.observable.fireEvent("request:errorManager.handleError", code);
    },

    /**
     * Handles when an error is triggered.
     *
     * @param {number} code The error code.
     * @param {string} description The error description.
     * @returns {void}
     */
    _errorTriggered: function(code, description) {
        this.publish("triggered", code, description);
    },

    /**
     * Handles when an error is resolved.
     *
     * @returns {void}
     */
    _errorResolved: function() {
        this.publish("resolved");
    },

    /**
     * Handles when a dialog was closed.
     *
     * @param {Object} dialog The information regarding the dialog that was closed.
     * @param {string} dialog.name The name of the dialog that was closed.
     * @returns {void}
     */
    _dialogBoxClosed: function(dialog) {
        if (dialog && dialog.name === "error") {
            this._errorResolved();
        }
    }
};

Services.Error = Sys.extend(Services.Base, Services.Error, "Services.Error");
